/* -------------------------------------------------------------------------- */
/*                               Types Financing                              */
/* -------------------------------------------------------------------------- */

export const TYPES_FINANCING = [
	{ value: 'LIMITED', label: 'global.limited' },
	{ value: 'UNLIMITED', label: 'global.unlimited' },
];
